import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TimeOffDialogContextType {
  isOpen: boolean;
  openTimeOffDialog: () => void;
  closeTimeOffDialog: () => void;
}

const TimeOffDialogContext = createContext<TimeOffDialogContextType | undefined>(undefined);

interface TimeOffDialogProviderProps {
  children: ReactNode;
}

export function TimeOffDialogProvider({ children }: TimeOffDialogProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const openTimeOffDialog = () => setIsOpen(true);
  const closeTimeOffDialog = () => setIsOpen(false);

  return (
    <TimeOffDialogContext.Provider
      value={{
        isOpen,
        openTimeOffDialog,
        closeTimeOffDialog,
      }}
    >
      {children}
    </TimeOffDialogContext.Provider>
  );
}

export function useTimeOffDialog() {
  const context = useContext(TimeOffDialogContext);
  if (context === undefined) {
    throw new Error('useTimeOffDialog must be used within a TimeOffDialogProvider');
  }
  return context;
}